// @flow
import styled from 'styled-components';

export const HeadingStyles = styled.h1`
    font-size: 2rem;
    font-weight: 500;
    line-height: 2rem;
    margin-top: 0;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/headings/page-title/styles.js